import Styles from './SideNavBar.module.css'
import { Colors, Images } from 'Theme'
import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import Fade from '@mui/material/Fade'
import { IFsvg } from 'Components'
import PropTypes from 'prop-types'
import InfinityEnums from 'Enums/InfinityEnums'
import history from 'history/browser'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { styled as muiStyled } from '@mui/system'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

const getSelectedIndex = (pathname, newPages) => {
  const slashArray = pathname.split('/')
  const result = newPages.findIndex(
    (page) => page.endpoint === '/' + slashArray[1],
  )
  return result
}

const onMapsPage = (pathname) => {
  if (pathname.includes('map')) return true
  else return false
}

const calculateMidpoint = (index) => {
  // 16 padding
  // 40 div height
  // 20 center of div
  return 16 + 40 * index + 20 + 16 * index
}

const IconContainer = styled.button`
  color: ${Colors.white};
`

const IconsDiv = styled.div`
  clip-path: polygon(
    0% 0%,
    0% 100%,
    100% 100%,
    100% ${(props) => props.triangleMidpoint + props.offset}px,
    87.5% ${(props) => props.triangleMidpoint}px,
    100% ${(props) => props.triangleMidpoint - props.offset}px,
    100% 0%
  );
`

const SideBarItem = styled.div`
  display: flex;
  border-left: 2px solid;
  justify-content: space-between;
  box-sizing: border-box;
  margin-left: 1px;
  &:hover {
    border-color: ${Colors.SideBarItemHover} !important;
  }
`

const SideNavBar = ({ initialIndex = 0, avatar, permissions, logoUrl }) => {
  const navigate = useNavigate()

  const displayedPages = [
    {
      icon: IFsvg.Flash,
      endpoint: '/sites',
      role: InfinityEnums.OperatorUserPermission.CAN_VIEW_STATION_CHARGEPOINT,
      title: 'Sites',
    },
    {
      icon: IFsvg.Admin,
      endpoint: '/operatorUsers',
      role: InfinityEnums.OperatorUserPermission.CAN_VIEW_OPERATOR_USER,
      title: 'Operator Users',
    },
    {
      icon: IFsvg.Globe,
      endpoint: '/map',
      role: InfinityEnums.OperatorUserPermission.CAN_VIEW_STATION_CHARGEPOINT,
      title: 'Map',
    },
    {
      icon: IFsvg.Alert,
      endpoint: '/operatorAlerts',
      role: InfinityEnums.OperatorUserPermission.CAN_VIEW_ALERT,
      title: 'Operator Alerts',
    },
    {
      icon: IFsvg.Analytics,
      endpoint: '/analyticsData',
      role: InfinityEnums.OperatorUserPermission.CAN_VIEW_ANALYTICS_DATA,
      title: 'Analytics',
    },
    {
      icon: IFsvg.Tariff,
      endpoint: '/tariffs',
      role: InfinityEnums.OperatorUserPermission.CAN_VIEW_TARIFF,
      title: 'Tariffs',
    },
  ]
  displayedPages.splice(1, 0, {
    icon: IFsvg.Card,
    endpoint: '/cards',
    role: InfinityEnums.OperatorUserPermission.CAN_VIEW_CHARGING_TOKEN,
    title: 'Cards',
  })

  const StyledTooltip = muiStyled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: Colors.primary,
      color: Colors.white,
      fontSize: '0.875rem',
      fontFamily: 'ProximaNova',
      padding: '0.3rem',
      marginLeft: '0.313rem',
      alignSelf: 'center',
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: Colors.ToolTipNavBar,
    },
  }))
  const [newPages, setNewPages] = useState([])
  const [selectedIndex, setSelectedIndex] = useState(
    getSelectedIndex(window.location.pathname, newPages),
  )
  const [triangleMidpoint, setTriangleMidpoint] = useState(
    calculateMidpoint(initialIndex),
  )
  const offset = 8
  let location = useLocation()

  useEffect(() => {
    const index = getSelectedIndex(location.pathname, newPages)
    setSelectedIndex(index)
    setTriangleMidpoint(calculateMidpoint(index))
  }, [location])

  useEffect(() => {
    if (!permissions || permissions.length === 0) return
    else {
      checkPermissions()
    }
  }, [permissions])

  const checkPermissions = () => {
    setNewPages([])
    let tempPages = []
    for (let page of displayedPages) {
      if (
        page.role &&
        permissions.some((permission) => permission === page.role)
      )
        tempPages.push(page)
    }
    setNewPages(tempPages)
    const index = getSelectedIndex(window.location.pathname, tempPages)
    setSelectedIndex(index)
    setTriangleMidpoint(calculateMidpoint(index))
  }

  return (
    <div
      className={
        onMapsPage(window.location.pathname)
          ? Styles.SideNavBarWrappingDivMap
          : Styles.SideNavBarWrappingDiv
      }
    >
      <Link to="/">
        <div className={Styles.logoWrappingDiv}>
          <img
            className={Styles.logo}
            src={logoUrl ? logoUrl : Images.newLogo}
            alt="logo"
          />
        </div>
      </Link>
      <IconsDiv
        offset={offset}
        triangleMidpoint={triangleMidpoint}
        className={Styles.iconsWrappingDiv}
        style={{
          backgroundColor: Colors.primary,
          boxShadow: `0px 0px 4px ${Colors.BoxShadow}`,
        }}
      >
        {newPages.map((page, index) => (
          <div onClick={() => {}} className={Styles.IconDiv}>
            <Link
              key={`link ${index}`}
              to={page.endpoint}
              style={{ width: '100%' }}
              onClick={() => {
                setSelectedIndex(index)
                setTriangleMidpoint(calculateMidpoint(index))
                history.push(page.endpoint)
                navigate(page.endpoint)
              }}
            >
              <StyledTooltip
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 60 }}
                title={page.title}
                placement="right"
              >
                <SideBarItem
                  style={{
                    borderColor:
                      index === selectedIndex
                        ? Colors.white
                        : Colors.transparent,
                  }}
                >
                  <IconContainer
                    shouldHover={selectedIndex !== index}
                    key={index}
                    className={Styles.iconContainer}
                    style={{
                      backgroundColor: Colors.primary,
                    }}
                  >
                    <page.icon fill={Colors.white} width={30} height={30} />
                  </IconContainer>
                </SideBarItem>
              </StyledTooltip>
            </Link>
          </div>
        ))}

        <div className={Styles.bottomContainer}>
          <div className={Styles.TitleWrappingDiv}></div>

          <div
            className={Styles.AvatarWrappingDiv}
            style={{ backgroundColor: Colors.transparent }}
            onClick={() => {
              setSelectedIndex()
              navigate('/operatorUserProfile', {
                replace: true,
                state: { refresh: Date.now() },
              })
            }}
          >
            {avatar}
          </div>
        </div>
      </IconsDiv>
    </div>
  )
}

SideNavBar.propTypes = {
  initialIndex: PropTypes.number,
  avatar: PropTypes.object,
  onLogoutClick: PropTypes.func,
}

export default SideNavBar
